// UploadStep.tsx

import React, { useContext, useState } from 'react'
import LoadingGif from '../../../../assets/loading'
// import { FileInput, StyledFileInput, UploadButton } from './style'
import ImportFromExcelContext from '../../../../contexts/ImportFromExcelContext'
import StockContext from '../../../../contexts/StockContext'
import {
  Container,
  HeaderDiv,
  HeaderText,
  CloseDiv,
  CloseImg,
  ProgressBarDiv,
  ProgressBarCircle,
  ProgressBarLine,
  Phrase,
  LoadingMessage,
  ProgressContainer,
  ProgressFill,
  FileInputDiv,
  FileInputLabel,
  FileInput,
  FileInfoDiv,
  FileInfoImg,
  FileMiddleDiv,
  FileUpperMiddleDiv,
  FileName,
  FilePercentage,
  FileInfoCancelImg,
  FileFirstText,
  FileSecondText,
  ButtonsDiv,
  CancelButton,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  DisabledNextButtonDiv,
  DisabledNextButtonImage,
  DisabledNextButtonText,
} from './style'
import cross from '../../../../assets/addStockModal/cross.svg'
import fileIcon from '../../../../assets/addStockModal/excel/file.svg'
import cancelIcon from '../../../../assets/addStockModal/excel/cancel.svg'
import arrowRight from '../../../../assets/addStockModal/excel/arrow-right.svg'
import disabledArrowRight from '../../../../assets/addStockModal/excel/disabled-arrow-right.svg'
import UserContext from '../../../../contexts/UserContext'
import axios from 'axios'
import ModalContext from '../../../../contexts/ModalContext'

const UploadStep = () => {
  const { tableFile, setTableFile } = useContext(StockContext)
  const { setModalActive, setModalSection } = useContext(ModalContext)
  const { token } = useContext(UserContext)
  const {
    activeTab,
    setActiveTab,
    setPreviewSpreadsheet,
    setTranslationMapping,
    loadingPercentage,
    setLoadingPercentage,
  } = useContext(ImportFromExcelContext)
  const [loadingMessage, setLoadingMessage] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)

  /**Para acompanhar o progresso do upload do arquivo
   * será chamada periodicamente para atualizar a barra
   * de progresso com base no progresso real do upload */
  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files: any = e.target.files!
    setTableFile(files)
    const formData = new FormData()
    formData.append('file', files[0])
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', (e) => ProgressHandler(e))
    xhr.open('POST', 'fileupload.php')
    xhr.send(formData)
  }

  /**O progresso é atualizado aqui, que é chamada
   * quando ocorre um evento de progresso durante o envio do arquivo.
   * Também é calculado a porcentagem */
  const ProgressHandler = (e: ProgressEvent<XMLHttpRequestEventTarget>) => {
    const percent = (e.loaded / e.total) * 100
    const newPercentage = [percent.toFixed(0)]
    setLoadingPercentage(newPercentage)
  }

  /**Aqui, a barra de progresso é desenhada usando um elemento <div> com a classe ProgressContainer,
   * e a largura é controlada pelo estilo inline do elemento ProgressFill, que recebe a largura correspondente
   *  ao progresso concluído, calculado em porcentagem. */
  const ProgressBar = (props: any) => {
    const fillerStyles = {
      width: `${props.completion}%`,
    }

    return (
      <ProgressContainer>
        <ProgressFill style={fillerStyles} />
      </ProgressContainer>
    )
  }

  const handleDelete = () => {
    const erasedFile = undefined
    const erasedPercentage = []
    setTableFile(erasedFile)
  }

  const handleSubmit = () => {
    const formData = new FormData()
    formData.append('file', tableFile[0])

    const file = tableFile[0]
    setLoading(true)
    setLoadingMessage('Carregando')
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/excel-preview`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        setLoadingMessage('Concluído !')
        setPreviewSpreadsheet(res.data)
        setTranslationMapping({})
        setTimeout(() => {
          // setActiveTab(1)
          setModalSection('secondExcelAdd')
        }, 1000)
      })
      .catch((err) => {
        setLoadingMessage('Erro ao tentar carregar !')
      })
  }

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  // Função para lidar com o evento de drop
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      setTableFile([files[0]]);
      const formData = new FormData();
      formData.append('file', files[0]);

      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (e) => ProgressHandler(e));
      xhr.open('POST', 'fileupload.php');
      xhr.send(formData);
    }
  };

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>Adicionar estoque</HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <ProgressBarDiv>
        <ProgressBarCircle className='active' />
        <ProgressBarLine />
        <ProgressBarCircle />
        <ProgressBarLine />
        <ProgressBarCircle />
      </ProgressBarDiv>
      <Phrase>
        <p>
          Faça upload da planilha em formato .xslx (Excel). Cada linha deve ser
          um produto com código (SKU) diferente, enquanto cada coluna deve ser
          um tipo de informação (Material, Formato, Acabamento, etc).
        </p>
        <p>
          <a href='../../../Estoque.xlsx' download>
            Baixar planilha padrão
          </a>
        </p>
        <p>
          <a href='../../../Regras_de_importacao.docx' download>
            Regras de importação
          </a>
        </p>
      </Phrase>
      {tableFile === undefined ? (
        <FileInputDiv
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <FileInputLabel htmlFor='invoice'>
            Procurar
            <FileInput
              type='file'
              id='invoice'
              name='invoice'
              onChange={handleUpload}
            />
          </FileInputLabel>
          <FileFirstText>ou arraste um arquivo até aqui</FileFirstText>
          <FileSecondText>
            Apenas arquivos .pdf de no máximo 10mb
          </FileSecondText>
        </FileInputDiv>
      ) : (
        <>
          <FileInfoDiv>
            <FileInfoImg src={fileIcon} alt='File icon' />
            <FileMiddleDiv>
              <FileUpperMiddleDiv>
                <FileName>{tableFile[0].name}</FileName>
                <FilePercentage>{loadingPercentage[0]}%</FilePercentage>
              </FileUpperMiddleDiv>
              <ProgressBar completion={loadingPercentage[0]} />
            </FileMiddleDiv>
            <FileInfoCancelImg
              src={cancelIcon}
              alt='File icon'
              onClick={() => handleDelete()}
            />
          </FileInfoDiv>
          {loading ? (
            <LoadingMessage>
              {loadingMessage}
              {loadingMessage === 'Carregando' && <img src={LoadingGif}></img>}
            </LoadingMessage>
          ) : null}
        </>
      )}
      <ButtonsDiv>
        <CancelButton onClick={() => setModalSection('addStockMenu')}>
          Cancelar
        </CancelButton>
        {tableFile === undefined ? (
          <DisabledNextButtonDiv onClick={() => handleSubmit()}>
            <DisabledNextButtonImage
              src={disabledArrowRight}
              alt='Right arrow icon'
            />
            <DisabledNextButtonText>Próximo</DisabledNextButtonText>
          </DisabledNextButtonDiv>
        ) : (
          <NextButtonDiv onClick={() => handleSubmit()}>
            <NextButtonImage src={arrowRight} alt='Right arrow icon' />
            <NextButtonText>Próximo</NextButtonText>
          </NextButtonDiv>
        )}
      </ButtonsDiv>
      {/* <StyledFileInput>
        Arraste para cá ou faça o upload
        <UploadButton htmlFor='table'>Selecione o arquivo</UploadButton>
        <FileInput
          type='file'
          id='table'
          name='table'
          onChange={handleUpload}
        />
      </StyledFileInput>
      {tableFile !== undefined ? (
        <>
          <ProgressDiv>
            <Icon src={FileImg} alt='Imagem de arquivo' />
            <FileName>
              {tableFile && tableFile[0]
                ? tableFile[0].name
                : 'Nenhum arquivo selecionado'}
            </FileName>

            <Percentage>{loadingPercentage}%</Percentage>
            <ProgressBar completion={loadingPercentage} />
            <ActionIcon
              src={CancelImg}
              alt='Ação'
              onClick={() => handleDelete()}
            />
          </ProgressDiv>

          {loading ? (
            <LoadingMessage>
              {loadingMessage}
              {loadingMessage === 'Carregando' && <img src={LoadingGif}></img>}
            </LoadingMessage>
          ) : (
            <NextButton onClick={() => handleSubmit()}>
              Próxima etapa
            </NextButton>
          )}
        </>
      ) : (
        <DisabledNextButton disabled>Próxima etapa</DisabledNextButton>
      )} */}
    </Container>
  )
}

export default UploadStep
